import React, { ComponentProps, useCallback, ChangeEventHandler } from 'react';
import { noop } from '@prisjakt/ui-base';
import * as S from './styles';

export {
  SIZE as PRODUCT_CHECKBOX_SIZE,
  hoverStyle as productCheckboxHoverStyle,
} from './styles';

type Props = {
  onSelect?: () => void;
  onDeselect?: () => void;
} & ComponentProps<typeof S.Wrapper>;

const ProductCheckbox = ({
  selected,
  name,
  onSelect = noop,
  onDeselect = noop,
  ...wrapperProps
}: Props) => {
  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    e => (e.target.checked ? onSelect() : onDeselect()),
    [onSelect, onDeselect]
  );

  return (
    <S.Wrapper selected={selected} {...wrapperProps}>
      <S.Input
        id={name}
        name={name}
        type="checkbox"
        checked={selected}
        onChange={onChange}
        tabIndex={0}
        value={selected ? '1' : '0'}
      />

      {selected && <S.Icon />}
    </S.Wrapper>
  );
};

export default ProductCheckbox;
